import React, { useState, useEffect} from 'react';
import "../assets/css/styles.table.css"
import Layout from './Layout';
//for table
import Box from '@mui/material/Box';
import ConfirmationButton from '../components/ConfirmationButton';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import FormControl from '@mui/material/FormControl';
import ApprovalDetailDialog from './ApprovalDetailDialog';
import {useRakApprovalHook} from '../hook/RakApprovalHook'
//import DynamicDataGrid from '../components/DynamicDataGrid'
import GridNumberPaging from '../components/GridNumberPaging.js'
import Bindcomponent from '../utils/bindcomponent.js';
const RakApproval = () => {
  const {message,setmessage,tipe,settipe,columns,rows, openRetention,handleRetentionClose,handleSaveDecline,notes,setNotes,approvalopen,setapprovalopen,rowsDetail,projectId
        } = useRakApprovalHook();
 
  return (
    <>
  <Layout message={message} setmessage={setmessage} tipe={tipe} settipe={settipe}>
  <div className='pd'><b> APPROVAL LIST</b> 
 
  </div>
 
  <div className="pd">
     
  <Box sx={{ width: 1 }} >
      
      <Box sx={{ height: "100%" }} >
        <Bindcomponent component='GridNumberPaging' customcolumns={columns} rows={rows} rowid={"id"} name="rakapprovalgrid" ></Bindcomponent>
        {/* <GridNumberPaging customcolumns={columns} rows={rows} rowid={"id"} name="rakapprovalgrid" ></GridNumberPaging> */}
        
      </Box>
    </Box>
    </div>
 

      <Dialog
        open={openRetention}
        onClose={handleRetentionClose}
        height={450}
        
      >
        
        <form id="formRetention" onSubmit={handleSaveDecline} >
        <DialogContent>
          <DialogContentText>
          <h4>Reason</h4><br></br>
          
            <hr></hr>
          </DialogContentText>
         
           <FormControl sx={{ m: 1}} size="small" > 
          
              <div className='form-group row'>
                {/* <label class="col-sm-4">Retention</label> */}
                <div class="col-sm-12">
                <textarea  rows="5" cols="50"  className="form-control"  value={notes} onChange={(e) => setNotes(e.target.value)}  />
              </div>
               
            </div>
             
          
           </FormControl>       
           <hr></hr>
        </DialogContent>
        <DialogActions>
          <button className='btn btn-danger' onClick={() => handleRetentionClose()} type="button">CANCEL</button>
          {/* <button className='btn btn-primary' type="submit">SAVE1</button>   */}
          <ConfirmationButton classname='btn btn-primary' text="Do you want save this data?" type="submit"  title="Save"  formid="formRetention" id="btnSubmit" >
               SAVE    
           </ConfirmationButton>
        </DialogActions>
        </form>    
      </Dialog>

      <ApprovalDetailDialog  approvalopen={approvalopen} approvalclose={setapprovalopen} data={rowsDetail} projectId={projectId} ></ApprovalDetailDialog>
      </Layout>
    </>
  );
};

export default RakApproval;